import { BaseModel } from "../../model/shared/BaseModel";
import { requests } from "../../utils/helpers/api.services";
import { CLIENT_DASHBOARD_URL } from "../../utils/helpers/api.routes";
import { ICompanyQuery } from "../companies/dto/ICompanies";
import { IWorkflow } from "../workflow/dto/IWorkflow";

export const ClientDashboardService = {
  getAllWorkflows: (params: any): Promise<BaseModel<IWorkflow[]>> =>
    requests.get(`${CLIENT_DASHBOARD_URL}/workflows`, params),
  getAllContentWorkflows: (params: any): Promise<BaseModel<any[]>> =>
    requests.get(`${CLIENT_DASHBOARD_URL}/content-workflows`, params),
  getAllUsersClients: (): Promise<BaseModel<any[]>> =>
    requests.get(`${CLIENT_DASHBOARD_URL}/user-clients`),
  getAllDataHistory: (params: ICompanyQuery): Promise<BaseModel<any[]>> =>
    requests.get(`${CLIENT_DASHBOARD_URL}/tasks`, params),
  createDataHistory: (params: any) =>
    requests.post(`${CLIENT_DASHBOARD_URL}/tasks`, params),
  updateDataHistoryById: (id: number, params: any) =>
    requests.put(`${CLIENT_DASHBOARD_URL}/tasks/${id}`, params),
  getDataHistoryById: (id: number) =>
    requests.get(`${CLIENT_DASHBOARD_URL}/tasks/${id}`),
  deleteDataHistoryById: (id: number) =>
    requests.delete(`${CLIENT_DASHBOARD_URL}/tasks/${id}`),
  deleteFile: (id: number) =>
    requests.delete(`${CLIENT_DASHBOARD_URL}/tasks/document-delete/${id}`),
};
